import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("c7wXz"), parcelRequire.load("fqSlw"), parcelRequire.load("hHkzJ"), parcelRequire.load("3btCG"), parcelRequire.load("68Spg")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("c7wXz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("fqSlw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hHkzJ")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("3btCG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("68Spg")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
